import React from "react";
import {Box, Typography} from "@mui/material";
import styles from "./styles.module.css";
import Avatar from "../../../assets/images/Avatar.png"
import {Loader} from "../../index";
import {useTranslation} from "react-i18next";
import {ID_Params, useGetAvatarsQuery, useGetProfilesByIdQuery, useUpdateProfileMutation} from "../../../api/modules";

interface IProps {
    id: ID_Params
}

const ProfileImage: React.FC<IProps> = (props) => {
    const {t} = useTranslation("translations");
    const {id} = props
    const {data: avatars, isFetching} = useGetAvatarsQuery()
    const {data: profile, refetch} = useGetProfilesByIdQuery(id)
    const [updateProfile] = useUpdateProfileMutation()


    const handleChangeAvatar = async (key: number) => {
        if (id) {
            const res = await updateProfile({id, body: {avatar: key}}).unwrap();
            if (res) {
                refetch()
            }
        }
    }

    if (isFetching) return <Loader className={styles.loader}/>

    return (
        <div className={styles.content}>
            <Typography variant={"h2"} width={"100%"}>{t("Settings.profileImage")}</Typography>
            <Box className={styles.avatars}>
                {avatars?.map((e) => (
                    <img src={e.file || Avatar} alt={"avatar"} key={e.id} onClick={() => handleChangeAvatar(e.id)}
                         loading={"lazy"}
                         className={(profile && profile?.avatar?.id === e?.id) ? styles.active : ""}/>
                ))}
            </Box>
        </div>
    );
};

export default ProfileImage;
